import { useQuery, UseQueryResult } from "@tanstack/react-query";
import config from "../config.json";
import { createAxiosInstance } from "./ServicesHelpers";

const axiosInstance = createAxiosInstance(config.ADMIN_API_BASE_URL);

export type ProfilePaymentType = "POSTPAID" | "PREPAID";

export const fetchPaymentTypes = async (): Promise<ProfilePaymentType[]> => {
  try {
    console.log("Fetching payment types...");
    const response = await axiosInstance.get<ProfilePaymentType[]>(
      "/profile-payment-types"
    );
    console.log("Raw response from /profile-payment-types:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching payment types:", error.message || error);
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while fetching the payment types."
    );
  }
};

export const usePaymentTypeQuery = (): UseQueryResult<
  { label: string; value: string }[]
> => {
  const queryKey = ["fetchPaymentTypes", "all"];

  return useQuery({
    queryKey,
    queryFn: async () => {
      const paymentTypes = await fetchPaymentTypes();
      return paymentTypes.map((type) => ({ label: type, value: type })); 
    },
  });
};
